import User from './users/model'
import UserModule from './users/module'

import Page from './pages/model'
import PageModule from './pages/module'

import Ticket from './tickets/model'
import TicketModule from './tickets/module'

import Test from './tests/model'
import TestModule from './tests/module'

import Question from './questions/model'
import QuestionModule from './questions/module'

import QuestionOption from './question-options/model'
import QuestionOptionModule from './question-options/module'

import Application from './applications/model'
import ApplicationModule from './applications/module'

import Group from './groups/model'
import GroupModule from './groups/module'

import Cpo from './cpo/model'
import CpoModule from './cpo/module'

import Organization from './organizations/model'
import OrganizationModule from './organizations/module'

import QuestionHierarchy from './question-hierarchy/model'
import QuestionHierarchyModule from './question-hierarchy/module'

import Knowledge from './knowledges/model'
import KnowledgeModule from './knowledges/module'

import EducationPlan from './education-plan/model'
import EducationPlanModule from './education-plan/module'
import EducationPlanPosition from './education-plan/EducationPlanPosition'

import Share from './share/model'
import ShareModule from './share/module'


import Role from './roles/model'
import RoleModule from './roles/module'

import Position from './positions/model'
import PositionModule from './positions/module'

import UserRole from './user-roles/model'
import UserRoleModule from './user-roles/module'

import Book from './book'

export default [
    [User, UserModule],
    [Page, PageModule],
    [Ticket, TicketModule],
    [Test, TestModule],
    [Question, QuestionModule],
    [QuestionOption, QuestionOptionModule],
    [Application, ApplicationModule],
    [Group, GroupModule],
    [Cpo, CpoModule],
    [Organization, OrganizationModule],
    [QuestionHierarchy, QuestionHierarchyModule],
    [Knowledge, KnowledgeModule],
    [EducationPlan, EducationPlanModule],
    [Role, RoleModule],
    [Position, PositionModule],
    [UserRole, UserRoleModule],
    [EducationPlanPosition, {}],
    [Share, ShareModule],
    [Book, {}],
]
